export function trustpilotBehavior() {
  window.setTimeout(() => {
    if ($('.trustpilot-widget').height() === 0) {
      $('.trustpilot-widget-static').show()
    }
  }, 1000)
}
